export default __webpack_public_path__ + "static/media/ddl-blue.2d6fc2ee.svg";